export default __webpack_public_path__ + "static/media/appstore-badge-white.3f17c1b2.svg";